import React, { useState, useRef, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import axios from 'axios';
import constants from '../../constants/index';
import { cookieStorageUtility } from '../../utils/utilityFunctions';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const SyncFilter = ({ params, dateChange, paramChange, searchLogs, ota, reset: resetProps, setOtaDetails }) => {
  // State hooks
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [hotelList, setHotelList] = useState([]);
  const [otaList, setOtaList] = useState([]);
  const [otaIds, setOtaIds] = useState([]);

  // Ref for typeahead
  const typeaheadRef = useRef(null);

  // Style object
  const style = {
    chips: {
      background: '#e43d4e',
      color: '#fff',
      'font-size': '10px'
    }
  };

  // Handle remove function
  const onRemove = useCallback((selectedList, removedItem) => {
    setOtaDetails(selectedList);
  }, [setOtaDetails]);

  // Handle search function
  const handleSearch = useCallback((hotel) => {
    if (typeof hotel === 'undefined' || hotel === '') {
      return;
    }
    if (hotel.length > 2) {
      getHotelList(hotel);
    }
  }, []);

  // Get hotel list function
  const getHotelList = useCallback((hotel) => {
    setShowSearchLoader(true);
    
    axios(serverUrl + 'property/gethotellisting', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { page: 1, limit: 10, hotelName: hotel } }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setHotelList(response.data.data.list);
        } else {
          // Handle error - you might want to pass an error handler as prop
          console.error('Error fetching hotel list:', response.data.message);
        }
        setShowSearchLoader(false);
      })
      .catch(error => {
        console.error('Error fetching hotel list:', error);
        setShowSearchLoader(false);
      });
  }, []);

  // Reset function
  const resetFilter = useCallback(() => {
    if (typeaheadRef.current) {
      typeaheadRef.current.getInstance().clear();
    }
    resetProps();
  }, [resetProps]);

  return (
    <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1">
      <div className="row gutters-5">

        {/* From Date */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-calendar"></i>
            </span>
            <DatePicker
              inputProps={{ disabled: true }}
              placeholderText="From Date"
              dateFormat="yyyy-MM-dd"
              className="input pad_lft_rht5"
              name="fromDate"
              onChange={e => dateChange(e, 'fromDate')}
              selected={params.fromDate !== '' ? new Date(params.fromDate) : null}
              minDate={new Date()}
            />
          </div>
        </div>

        {/* To Date */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-calendar"></i>
            </span>
            <DatePicker
              inputProps={{ disabled: true }}
              placeholderText="To Date"
              dateFormat="yyyy-MM-dd"
              className="input pad_lft_rht5"
              name="toDate"
              onChange={e => dateChange(e, 'toDate')}
              selected={params.toDate !== '' ? new Date(params.toDate) : null}
              minDate={params.fromDate !== '' ? new Date(params.fromDate) : null}
            />
          </div>
        </div>

        {/* Channel Dropdown */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={params.channelId}
              onChange={e => paramChange(e, 'channelId')}
            >
              <option value="0">All Channel</option>
              {Object.keys(ota).length > 0 &&
              Object.keys(ota).map(id => {
                const data = ota[id];
                return (
                  <option value={data.channel_id} key={id}>
                    {data.ota_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* Hotel Search */}
        <div className="col-xs-12 col-md-4 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <AsyncTypeahead
              ref={typeaheadRef}
              inputProps={{ className: 'inputs' }}
              multiple={false}
              isLoading={showSearchLoader}
              options={hotelList}
              id={'hotel'}
              labelKey={'hotel'}
              minLength={3}
              align="justify"
              onSearch={handleSearch}
              placeholder={'Hotel'}
              filterBy={['hotel','hotel_code']}
              selectHintOnEnter
              onChange={selected => {
                paramChange(selected, 'hotelName');
              }}
              renderMenuItemChildren={(option, props) => (
                <span key={option.hotel_id} id={option.hotel_id}>
                  {option.hotel}
                </span>
              )}
            />
          </div>
        </div>

        {/* Sync Button */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div
            className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc"
            onClick={() => searchLogs()}
          >
            <i className="fa fa-filter marg_right7"></i> Sync
          </div>
        </div>

      </div>
    </div>
  );
};

export default SyncFilter;
